import { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import { listAddressBook, type AddressBookEntry } from '../api/addressBook';

type Props = {
  /** Chiamato quando l'utente seleziona una voce: il chiamante riempie lat/lon/address. */
  onPick: (entry: AddressBookEntry) => void;
};

/**
 * Pulsante "📕 Carica da rubrica" + dropdown delle voci salvate.
 * Lazy-load della lista al primo open, niente refetch successivi.
 */
export function AddressBookPicker({ onPick }: Props) {
  const [open, setOpen] = useState(false);
  const [entries, setEntries] = useState<AddressBookEntry[] | null>(null);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState<string | null>(null);

  useEffect(() => {
    if (!open || entries !== null) return;
    let cancelled = false;
    setLoading(true);
    setError(null);
    listAddressBook()
      .then((list) => {
        if (!cancelled) setEntries(list);
      })
      .catch((e: unknown) => {
        if (!cancelled) setError(e instanceof Error ? e.message : 'Errore caricamento');
      })
      .finally(() => {
        if (!cancelled) setLoading(false);
      });
    return () => {
      cancelled = true;
    };
  }, [open, entries]);

  function pick(entry: AddressBookEntry) {
    onPick(entry);
    setOpen(false);
  }

  return (
    <div className="address-book-picker">
      <button
        type="button"
        className="btn btn-ghost"
        onClick={() => setOpen((v) => !v)}
        aria-expanded={open}
      >
        📕 Carica da rubrica
      </button>
      {open && (
        <div
          className="picker-dropdown"
          onMouseDown={(e) => e.preventDefault() /* evita blur su input parent */}
        >
          {loading && <p className="muted">Caricamento…</p>}
          {error && <p className="err">{error}</p>}
          {entries && entries.length === 0 && (
            <p className="muted">
              La rubrica è vuota.{' '}
              <Link to="/settings" onClick={() => setOpen(false)}>
                Aggiungi una voce
              </Link>
              .
            </p>
          )}
          {entries && entries.length > 0 && (
            <ul className="picker-list">
              {entries.map((e) => (
                <li key={e.id}>
                  <button type="button" className="picker-row" onClick={() => pick(e)}>
                    <span className="picker-label">{e.label}</span>
                    {e.address && <span className="picker-address">{e.address}</span>}
                  </button>
                </li>
              ))}
            </ul>
          )}
        </div>
      )}
    </div>
  );
}
